// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"TestimonialCard_testimonial__3A5SB","testimonialImage":"TestimonialCard_testimonialImage__Ncqjh","testimonialText":"TestimonialCard_testimonialText__2zAwm"};